<template>
  <div>
    <h2>Conheça alguns de nossos projetos separados por <b>área</b></h2>
    <div class="categories">
      <Category v-for="(category, index) in areaCategories" :key="index" :categoryName="category.categoryName"/>
    </div>

    <h2>Ou veja nossos Projetos separados por <b>tipo de serviço</b></h2>
    <div class="categories">
      <Category v-for="(category, index) in serviceCategories" :key="index" :categoryName="category.categoryName"/>
    </div>
  </div>
</template>

<script>
import Category from '@/components/Category.vue'

export default {
  name: 'home',
  components: {
    Category
  },
  data: function () {
    return {
      categories: []
    }
  },
  computed: {
    areaCategories: function () {
      return this.categories.filter(function (c) {
        return c.type === 'area'
      })
    },
    serviceCategories: function () {
      return this.categories.filter(function (c) {
        return c.type === 'service'
      })
    }
  },
  created: function () {
    fetch('https://adminportfolio.emarketingbr.com.br/categories')
      .then((resp) => resp.json())
      .then((data) => {
        this.categories = data
      })
      .catch(err => {
        console.log(err)
      })
  }
}
</script>

<style scoped lang="scss">
  .categories {
    padding: 50px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 40px;

    @media screen and (max-width: 1000px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
      grid-gap: 20px;
      padding: 50px 20px;
    }
  }

  h2 {
    margin: 0;
    text-transform: uppercase;
    font-weight: 500;
  }
</style>
